import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { languages } from "../../models/company";
import store, { useAppSelector } from "../../store";

import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePutTemplate } from "../../hook/templates";
import { templatesActions } from "../../store/templates-slice";
import { queryClient } from "../../utils/http/queryClient";
import { deleteTemplate, fetchTemplate } from "../../utils/http/templates";
import { transformPathToUrl } from "../../utils/url";
import ModalPromote from "./ModalPromote";
import RenderingVariablesModal from "./RenderingVariablesModal";

function AutomationActionsTop() {
  const navigate = useNavigate();

  const activeCompany = useAppSelector((state) => state.company.activeCompany);

  const selectedPath = useAppSelector((state) => state.templates.selectedPath);
  const selectedVersion = useAppSelector((state) => state.templates.selectedVersion);
  const selectedLanguage = useAppSelector((state) => state.templates.selectedLanguage);
  const selectedTemplateSummary = useAppSelector((state) => state.templates.selectedTemplateSummary);

  const [versionsForSelectedPath, setVersionsPerSelectedPath] = useState<string[]>([]);
  const [showSendTestModal, setShowSendTestModal] = useState(false);
  const [showRenderingVariablesModal, setShowRenderingVariablesModal] = useState(false);

  const { mutate: copyToDraft } = usePutTemplate(selectedPath!, "draft");

  const { data: template = null } = useQuery({
    queryKey: ["mailTemplates", selectedPath!.namespace, selectedPath!.name, selectedVersion],
    queryFn: async ({ signal }) => {
      return await fetchTemplate({ signal, key: selectedPath!, version: selectedVersion });
    },
  });

  useEffect(() => {
    setVersionsPerSelectedPath(selectedTemplateSummary?.versions || []);
  }, [selectedTemplateSummary]);

  const changeLanguage = (language: string) => {
    store.dispatch(templatesActions.setSelectedLanguage(language));
    queryClient.invalidateQueries({
      queryKey: ["templateRender", selectedPath!.namespace, selectedPath!.name, selectedVersion],
    });
  };

  const { mutate: mutateDeleteDraft } = useMutation({
    mutationFn: deleteTemplate,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["templatesSummary"] });
      navigate(transformPathToUrl({ path: selectedPath!, version: "live" }));
    },
  });

  if (!selectedPath || !selectedTemplateSummary) {
    return <div></div>;
  }

  return (
    <>
      <Container className="mb-4">
        {versionsForSelectedPath.length > 0 && (
          <>
            <Row>
              <Col>
                <Container className="p-0">
                  <Row>
                    <Form.Group as={Col} xs={6} className="p-0 ps-1 pe-1">
                      <Form.Select
                        value={selectedLanguage}
                        onChange={(e) => {
                          changeLanguage(e.target.value);
                        }}
                        style={{ backgroundColor: "#e4e6f5" }}
                      >
                        {languages.map((l) => (
                          <option key={l.id} value={l.id}>
                            {l.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group as={Col} xs={6} className="p-0 ps-1 pe-1">
                      <Button
                        onClick={() => setShowRenderingVariablesModal(true)}
                        style={{
                          width: "100%",
                          backgroundColor: "#e4e6f5",
                          border: "none",
                          color: "#212529",
                          height: "38px",
                        }}
                      >
                        Variables
                      </Button>
                    </Form.Group>
                  </Row>
                </Container>
              </Col>
              <Col>
                {((activeCompany?.name !== "colibry" && !selectedPath.namespace.startsWith("colibry")) ||
                  activeCompany?.name === "colibry") && (
                  <Container className="p-0">
                    {selectedVersion === "draft" && (
                      <Row>
                        <Form.Group as={Col} className="p-0 ps-1 pe-1">
                          <Button
                            onClick={() => setShowSendTestModal(true)} //mutatePromoteDraft({ key: selectedPath! })}
                            style={{ width: "100%", border: "none", height: "38px" }}
                          >
                            Promote Draft
                          </Button>
                        </Form.Group>
                        <Form.Group as={Col} className="p-0 ps-1 pe-1">
                          <Button
                            onClick={async () => mutateDeleteDraft({ key: selectedPath!, version: "draft" })}
                            style={{
                              width: "100%",
                              backgroundColor: "#e4e6f5",
                              border: "none",
                              color: "#212529",
                              height: "38px",
                            }}
                          >
                            Delete Draft
                          </Button>
                        </Form.Group>
                      </Row>
                    )}
                    {selectedVersion === "live" && (
                      <Row>
                        <Form.Group as={Col} className="p-0 ps-1 pe-1"></Form.Group>

                        <Form.Group as={Col} className="p-0 ps-1 pe-1">
                          {!versionsForSelectedPath.includes("draft") && (
                            <Button
                              style={{ width: "100%" }}
                              onClick={() =>
                                copyToDraft({
                                  key: selectedPath,
                                  category: selectedPath.category,
                                  type: selectedTemplateSummary?.type,
                                  config: template?.config,
                                  content: template?.content,
                                })
                              }
                            >
                              Copy to Draft
                            </Button>
                          )}
                          {versionsForSelectedPath.includes("draft") && (
                            <Button
                              style={{ width: "100%" }}
                              onClick={() => navigate(transformPathToUrl({ path: selectedPath, version: "draft" }))}
                            >
                              Go to Draft
                            </Button>
                          )}
                        </Form.Group>
                      </Row>
                    )}
                  </Container>
                )}
              </Col>
            </Row>
            {/* <Row
            className="mt-2 align-items-center"
            style={{ backgroundColor: "#ffc9cd", padding: "10px", borderRadius: "5px", border: "1px solid #DC3444" }}
          >
            <Col xs={5} style={{ color: "#DC3444", fontWeight: "bold" }}>
              You have draft translations
            </Col>
            <Col xs={7}>
              <Container className="p-0">
                <Row>
                  <Form.Group as={Col} className="p-0 ps-1 pe-1">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-bottom`}>
                          We'll list all the translations that are in draft and being used in the render below. You will
                          be given the option to promote these draft translations.
                        </Tooltip>
                      }
                    >
                      <Button
                        onClick={async () => {}}
                        style={{
                          width: "100%",
                          backgroundColor: "#DC3444",
                          border: "none",
                          color: "#FFFFFF",
                        }}
                      >
                        Review...
                      </Button>
                    </OverlayTrigger>
                  </Form.Group>
                  <Form.Group as={Col} className="p-0 ps-1 pe-1">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-bottom`}>
                          You can generate the render below while not taking into account the draft translations. This
                          way you can see how the content looks with only live translations.
                        </Tooltip>
                      }
                    >
                      <Button
                        onClick={async () =>
                          dispatch(templatesActions.setShowOnlyLiveTranslations(!showOnlyLiveTranslations))
                        }
                        style={{
                          width: "100%",
                          backgroundColor: "#DC3444",
                          border: "none",
                          color: "#FFFFFF",
                        }}
                      >
                        {showOnlyLiveTranslations ? "Render with draft" : "Render with live"}
                      </Button>
                    </OverlayTrigger>
                  </Form.Group>
                </Row>
              </Container>
            </Col>
          </Row> */}
          </>
        )}
      </Container>
      {showSendTestModal && (
        <ModalPromote showSendTestModal={showSendTestModal} setShowSendTestModal={setShowSendTestModal} />
      )}
      {showRenderingVariablesModal && (
        <RenderingVariablesModal
          showModal={showRenderingVariablesModal}
          setShowModal={setShowRenderingVariablesModal}
        />
      )}
    </>
  );
}

export default AutomationActionsTop;
